import React from 'react';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const rootEl = document.getElementById('root');
const DISPLAY_NAME = 'portal';

class Portal extends React.Component {
  render() {
    const {children, className, id} = this.props;

    const portalElement = React.createElement(
      'div',
      {className: `${DISPLAY_NAME}${className ? `--${className}` : ''}`, id: `${DISPLAY_NAME}${id ? `--${id}` : ''}`},
      children,
    );

    return ReactDOM.createPortal(portalElement, rootEl);
  }
}

export default Portal;

Portal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
};

Portal.defaultProps = {
  children: null,
  className: '',
  id: '',
};
